// ---------------------------------------------------------------------------
// Redirecionamentos 301 — fonte única.
//
// As URLs antigas tinham a cidade no slug e já estão indexadas. Elas precisam
// continuar respondendo para sempre, apontando para as novas: é o 301 que
// transfere para o novo endereço o histórico que o Google já acumulou.
//
// scripts/prerender.js lê esta lista e gera o .htaccess (Apache) e o
// _redirects (Netlify/Cloudflare). Nunca remover uma linha daqui.
// ---------------------------------------------------------------------------

const redirecionamentos = [
  { de: '/advogado-tribunal-do-juri-brasilia', para: '/tribunal-do-juri' },
  { de: '/advogado-prisao-em-flagrante-brasilia', para: '/prisao-em-flagrante' },
  { de: '/advogado-crimes-contra-o-patrimonio-brasilia', para: '/crimes-contra-o-patrimonio' },
  { de: '/advogado-trafico-de-drogas-brasilia', para: '/trafico-de-drogas' },
  { de: '/advogado-violencia-domestica-brasilia', para: '/violencia-domestica' },
  { de: '/advogado-crimes-de-transito-brasilia', para: '/crimes-de-transito' },
  { de: '/advogado-crimes-economicos-brasilia', para: '/crimes-economicos' },
  { de: '/advogado-crimes-digitais-brasilia', para: '/crimes-digitais' },
  { de: '/advogado-execucao-penal-brasilia', para: '/execucao-penal' },
  { de: '/advogado-habeas-corpus-brasilia', para: '/habeas-corpus' },
];

export default redirecionamentos;

/** Destino de uma URL antiga, ou null se ela não foi renomeada. */
export function destinoDe(caminho) {
  const limpo = `/${String(caminho || '').replace(/^\/+|\/+$/g, '')}`;
  const item = redirecionamentos.find((r) => r.de === limpo);
  return item ? item.para : null;
}
